<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M39.5 30.5A1.5 1.5 0 0038 32v6H10v-7.88l2.44 2.44a1.51 1.51 0 001.06.44 1.54 1.54 0 001.15-.53 1.59 1.59 0 00-.17-2.11l-4.57-4.57a2 2 0 00-2.82 0l-4.65 4.65a1.5 1.5 0 002.12 2.12L7 30.12V39a2 2 0 002 2h30a2 2 0 002-2v-7a1.5 1.5 0 00-1.5-1.5zM45.56 15.44a1.49 1.49 0 00-2.12 0L41 17.88V9a2 2 0 00-2-2H9a2 2 0 00-2 2v7a1.5 1.5 0 003 0v-6h28v7.88l-2.44-2.44a1.5 1.5 0 00-2.12 2.12l4.65 4.65a2 2 0 002.82 0l4.65-4.65a1.49 1.49 0 000-2.12z"/></svg>